import { useState } from 'react'

/** Keep draft-discard confirmation visible in the page, rather than a browser dialog. */
export function ReleaseReview({ busy, hasDraft = false, onRelease }: {
  busy: boolean
  hasDraft?: boolean
  onRelease: () => Promise<void>
}) {
  const [confirming, setConfirming] = useState(false)
  const [releasing, setReleasing] = useState(false)
  async function release() {
    setReleasing(true)
    try { await onRelease() } finally { setReleasing(false); setConfirming(false) }
  }
  return <div className="review-release">
    {confirming && <p className="small muted">Release this review and discard your unsent edits?</p>}
    <div className="row">
      <button className="link small" disabled={busy || releasing} onClick={() => {
        if (hasDraft && !confirming) setConfirming(true)
        else void release()
      }}>
        {releasing ? 'Releasing…' : confirming ? 'Discard edits and release' : 'Release review'}
      </button>
      {confirming && <button className="link small" disabled={busy || releasing} onClick={() => setConfirming(false)}>Cancel</button>}
    </div>
  </div>
}
